import React, { useState } from 'react'

import toast from 'react-hot-toast'

import { Button, Input, SectionSubtitle } from '../../../..'
import { useStudents, useUser } from '../../../../../context'
import FormField from '../../../../FormField'
import { Spacer } from '../../../../global'

const LinksSection = () => {
  const { onEditionMode, setOnEditionMode } = useUser()
  const { activeStudent, saveStudent } = useStudents()

  const [dropboxLink, setDropboxLink] = useState<string | undefined>(
    activeStudent?.dropboxLink,
  )

  const handleSave = async () => {
    try {
      activeStudent &&
        (await saveStudent(
          { ...activeStudent, dropboxLink: dropboxLink },
          activeStudent.uid,
        ))
      toast.success('Link actualizado con exito')
    } catch (error) {
      toast.error('Hubo un error, por favor intentalo de nuevo más tarde.')
    } finally {
      setOnEditionMode(false)
    }
  }

  return (
    <>
      <SectionSubtitle
        children="Links del alumno"
        fontSize={18}
        fontWeight={500}
      />
      <Spacer height={30} />
      <FormField
        id="dropboxLink"
        label="Link de Dropbox:"
        labelClass="align-left"
      >
        <Input
          name="dropboxLink"
          id="dropboxLink"
          defaultValue={activeStudent?.dropboxLink}
          width="400px"
          disabled={!onEditionMode}
          onChange={(e) => setDropboxLink(e.target.value)}
        />
      </FormField>
      <Spacer height={20} />
      {onEditionMode ? (
        <div style={{ display: 'flex', gap: 20 }}>
          <Button
            label="Cancelar"
            onClick={() => setOnEditionMode(false)}
            className="light-grey"
          />
          <Button label="Guardar" onClick={handleSave} className="dark-grey" />
        </div>
      ) : (
        <Button
          label={
            activeStudent?.dropboxLink
              ? 'Cambiar el link'
              : 'Agregar link a Dropbox'
          }
          onClick={() => setOnEditionMode(true)}
          className="dark-grey"
        />
      )}
    </>
  )
}

export default LinksSection
